import { SearchResultItem } from "@towersystems/roam-common/lib/generated-types";
import { createContext } from "react";

export interface FulltextSearchContextType {
  loading: boolean;
  query: string;
  executedQuery: string;
  setQuery: (v: string) => void;
  clearSearchValue: () => void;
  items?: SearchResultItem[];
}

export const FulltextSearchContext = createContext<
  FulltextSearchContextType | undefined
>(undefined);

export const FulltextCustomerSearchContext = createContext<
  FulltextSearchContextType | undefined
>(undefined);

export const FulltextProductSearchContext = createContext<
  FulltextSearchContextType | undefined
>(undefined);
